
import { pp, notify } from '@helpers'

const notifies = {
    name: 'notifies',

    mounted(el, binding) {// , vnode, prevVnode
    // created(el, binding, vnode) {// , prevVnode

        var user = pp().user

        if(user){

            var key = _.keys(binding.value)?.[0]

            if( ! _.includes(user.notify, key)){

        // log('in directives NOTIFY',el,binding,vnode)

                let notif = document.createElement('span')
                // notif.append('blablabla')

                    // notif.append(binding.value[key]?.msg)
                    notif.title = binding.value[key]?.msg

                if(binding.value[key]?.new){
                    notif.append('New')
                    notif.classList.add('bg-green-9')
                } else {

                    if(binding.value[key]?.content){
                        notif.append(binding.value[key].content)
                    } else {
                        notif.append('?')
                    }

                    if(binding.value[key]?.bg){
                        notif.classList.add('bg-'+bg)
                    } else {
                        notif.classList.add('bg-info')
                    }
                }
                if(binding.value[key]?.class){// array
                    _.each(binding.value[key]?.class, (c)=>{
                        notif.classList.add(c)
                    })
                }

                notif.classList.add(/* 'notify-'+key, */'q-badge','flex','inline','items-center','no-wrap','q-badge--single-line','q-badge--floating','q-badge--rounded','text-bold'/* ,'q-pa-xs' */,'q-ma-xs')

                notif.style.padding = '3px 5px'

                notif.role = 'status'


                el.classList.add('relative-position')

                el.append(notif)

                el.addEventListener('click',()=>{

                    axios.get(route('user-notified', {user_id: user.id, key: key}))
                        .then((res)=>{
                            user.notify = res.data

                            _.last(el.childNodes).remove()
    // log('ONCLICK', el, vnode, res)
                        })
                },{
                    once: true,
                    passive: true
                })
            }
        }
    }
}



import my_gsap from './gsap.conf'

const gsinit = {
    name:'gsinit',

    mounted(el, binding, vnode) {// , prevVnode
// log(binding)
        var user = pp().user

        if( ! vnode.ctx?.appContext.config.globalProperties.$_isMobile && (!user || user?.custom?.animations)){
        // if( ! acg.$_isMobile && (!user || user?.custom?.animations)){
        // if( ! $_isMobile && (!user || user?.custom?.animations)){

        // log('in directives - gsinit',vnode.ctx?.appContext.config.globalProperties, vnode, user)

            var delay = 0.3

            function autoAnime(binding){

                if(binding.value){ // delay   ex: v-gsinit="10"
                    delay = binding.value
                }
                if(binding.arg?.value){ // ex: v-gsinit:slide-right="0"  (delay = 0)
                    delay = binding.value
                }

                if(binding.arg == 'fade'){ // ex: v-gsinit:fade
                    binding.value = [{},{duration:0.7}]
                }
                else if(binding.arg == 'slide-up'){// apparent coming from the up
                    binding.value = [{y:100},{y:0,duration:0.6}]
                }
                else if(binding.arg == 'slide-down'){// apparent coming from the down
                    binding.value = [{y:-70},{y:0,duration:0.6}]
                }
                else if(binding.arg == 'slide-right'){// apparent coming from the right
                    binding.value = [{x:-80},{x:0,duration:0.6}]
                }
                else if(binding.arg == 'slide-left'){// apparent coming from the left
                    binding.value = [{x:80},{x:0,duration:0.6}]
                }
                return binding
            }

            if( ! _.isArray(binding.value) && ! binding.arg){ // v-gsinit  alone (with maybe a delay in value...)
                binding.arg = 'slide-up'
            }
            if(binding.arg){
                autoAnime(binding)
            }


            // el.classList.add('unvisible') // requis pour de "belles apparitions"..... (opacity:0 in css)

            // _.delay(()=>{
            //     el.classList.remove('unvisible') // ... mais, on sait jamais ...
            // },4000)


            if(vnode.props?.id){
                var anchor = '#'+vnode.props.id //! faut forcément une 'class' spécifique ou un 'id' sur l'élément
            } else {

                var uniq_id = _.uniqueId('gs-')
                el.setAttribute('id', uniq_id)

                var anchor = '#'+uniq_id
            }

            if(anchor){
                var replay = {}
                var is_replay = _.has(binding.value[1], 'replay')
                if(is_replay){
                    replay = binding.value[1] //  {Bool | Object}  -  ex  {start: 80,end:60}
                }

                // _.defer(()=>{
                    // _.delay(()=>{


                    my_gsap
                        .fromTo(anchor, {
                            opacity: 0,
                            ...binding.value[0],

                            // stagger: 0.2,
                            // stagger: {
                            //     // each: 0.1,
                            //     from: "center", // 'start', 'center', 'edges', 'random' ou 'end'
                            //     // amount: 1,
                            //     // grid: [7,15],
                            //     // axis: "y",
                            //     // ease: "power2.inOut",
                            //     // repeat: -1 // Repeats immediately, not waiting for the other staggered animations to finish
                            // }

                        },{
                            // immediateRender: false,
                            // overwrite: true,
                            // paused: true,
                            // offset: '-300px', NON
                            opacity: 1,
                            delay: delay,
                            duration: 0.8,
                            ease: 'power2.out', // default power1.out // https://greensock.com/docs/v3/Eases
                            // ...(binding.value[1] || {}),
                            ...binding.value[1],

                            scrollTrigger: // https://greensock.com/docs/v3/Plugins/ScrollTrigger // EX: https://codepen.io/GreenSock/pen/RwPXQOQ
                            // anchor,
                            !is_replay ? anchor :
                            {
                                trigger: anchor,
                                start: "top "+(replay?.start || 75)+'%',
                                end: "top "+(replay?.end || 40)+'%',
                                scrub: true,

                                //   markers: true, //? for tests
                                //   id: "scrub_"+anchor //? for tests
                            },

                        })
                    // },100)
                // })
            } else {
                notify('warning', "La directive v-gsinit attend un id ou une class...!")
            }
        }
    }
}


export default {
    install(app/* , options */){

        app.directive('notifies', notifies)

        app.directive('gsinit', gsinit, {})/* {}  pour utiliser un argument sur la directive. Du genre v-gsinit:slide-down */
    }
}
